// hook to dispatch snackbar message

import { showSnackbar } from '@/features/snackbar/snackbarSlice'
import { useAppDispatch } from './useAppDispatch'
import SnackbarSeverity from '@/types/SnackbarSeverity'

export const useSnackbar = () => {
  const dispatch = useAppDispatch()

  const show = (message: string, severity: 'success' | 'info' | 'warning' | 'error' = 'success') => {
    dispatch(showSnackbar({
      message,
      severity,
    }))
  }

  return { showSnackbar: show }
}